import React, { useCallback } from 'react';
import { BusinessMembers as BusinessMembersUI } from '../../ui/business/BusinessMembers';
import { canEditBusiness } from '../../utils/accessService';
import { ymTrackSettingsCreateInvite } from '../../utils/metrika';
import { useOpenDialog } from '../ModalRoute';
import { DIALOGS } from '../constants';
import { useCurrentUser } from '../users/useCurrentUser';
import { useBusinessMembers } from './useBusinessMembers';

interface BusinessMembersProps {
    businessId: string;
}

export const BusinessMembers = (props: BusinessMembersProps) => {
    const { businessId } = props;
    const currentUser = useCurrentUser();
    const { members, onRemove, onApprove, isLoading } = useBusinessMembers(businessId);
    const openDialog = useOpenDialog();
    const onOpenInviteMemberDialog = useCallback(() => {
        ymTrackSettingsCreateInvite({
            page: 'Настройки бизнеса',
            userLogin: currentUser?.login,
            businessId: currentUser?.profile?.publicId,
        });
        openDialog(DIALOGS.CREATE_INVITE);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openDialog]);

    return (
        <BusinessMembersUI
            items={members}
            onRemove={onRemove}
            onApprove={onApprove}
            onOpenInviteMemberDialog={onOpenInviteMemberDialog}
            isLoading={isLoading}
            canEditBusiness={canEditBusiness(businessId, currentUser)}
        />
    );
};
